export const usocomercialcomercial ={
    data: {
       leadId: "00QD5000009tCp2MAE",
       quotesResponse: false
     },
    error: false
 }		
 
export const usocomercialcomercialBitacora = {
    data: {
        leadId: "00QD5000009tCp2MAE",
        quotesResponse: false,
        bitacoraId: "4AS42ZSDD00010A0A1",
    },
    error: false
};
					
					
					
					
					
					
 
 // escenarios donde no pasa los 5 millones y es recidencial
 
 export const usoresidencialsuccess ={
     data: {
         leadId: "00Qdq0000018tDFEAY",
         scoreAnalitico: "Suscribe",
         

     },
     error: false
 }		
 
 export const usoresidencialsuccessBitacora ={
    data: {
        leadId: "00Qdq0000018tDFEAY",
        scoreAnalitico: "Suscribe",
        bitacoraId: "4AS42ZSDD00010A0A1",

    },
    error: false
}
 
                     
 
 export const  nosuscribeconposibilidadBitacora ={// suscribe si hay codeudor
     data: {
         leadId: "00QD5000009tCp2MAE",
         scoreAnalitico: "No suscribe (con posibilidad si hay Codeudor)",
         bitacoraId: "4AS42ZSDD00010A0A1",
     },
     error: false
 }					
                     
 export const nosuscribesinposibilidad = {
     data: {
         leadId: "00Qdq0000018pBFEAY",
         scoreAnalitico: "No suscribe (sin posibilidad, incluso con Codeudor)"
     },
     error: false
 }				
 
 
 export const errorconsumo = {
     data: {
         leadId: "00Qdq0000018tDFEAY",
         scoreAnalitico: "Falló el servicio"
     },
     error: true
 }			
 